module.exports = __webpack_public_path__ + "media/nyan1.fa830c2d.mp3";